import { ChangeDetectionStrategy, Component, Signal, computed, input } from '@angular/core';

import { Store } from '@ngrx/store';

import { IBetslipRootState } from '../../../base/store/state';
import { selectCurrentInfoMessageId } from '../selectors';

@Component({
    standalone: true,
    selector: 'bs-info-message-container',
    templateUrl: './info-message-container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoMessageContainerComponent {
    readonly messageId = input.required<string>();

    readonly currentInfoMessageId: Signal<string | null>;
    readonly isMessageVisible: Signal<boolean>;

    constructor(store: Store<IBetslipRootState>) {
        this.currentInfoMessageId = store.selectSignal(selectCurrentInfoMessageId);
        this.isMessageVisible = computed(() => this.currentInfoMessageId() === this.messageId());
    }
}
